<template>
  <status-chip
    :status="status"
    :statuses="types"
  ></status-chip>
</template>

<script>
import { ref } from '@vue/composition-api'
import StatusChip from '@/components/chips/StatusChip.vue'
import useIsPaymentList from '@/components/lists/isPayment'

export default {
  components: {
    StatusChip,
  },
  props: {
    status: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const { isPaymentList } = useIsPaymentList()
    const types = ref(isPaymentList)

    return {
      types,
    }
  },
}
</script>
